import axios from 'axios'

export function mochpBootstrap() {
  return axios.get('/mochp/precheck', {
    withCredentials: true
  }).then(function (res) {
    const data = res.data
    if (!data || !data.isMocReady || !data.mocCommonFrameEsmJsSrc) {
      console.log('MOC ready: false MOC enabled: ', data.isMocEnabled)
      return {isMocReady: false, isMocEnabled: data.isMocEnabled}
    }

    // Prevent double load
    if (!customElements.get('mochp-frame')) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script')
        script.type = 'module'
        script.src = data.mocCommonFrameEsmJsSrc
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      }).then(function () {
        var frame = document.createElement('mochp-frame')
        var header = document.createElement('mochp-header')
        frame.appendChild(header)
        document.body.prepend(frame)

        frame.setAttribute('app-code', 'rtr')
        frame.addEventListener('userSignOut', function (e) {
          console.info('User signed out', e.detail)
          if (e.detail.signOutAppCode === 'rtr') {
            window.open(e.detail.signOutUrl, '_self')
          } else {
            frame.showLoggedOutDialog()
          }
        })

        console.log('MOC ready: true MOC enabled: ', data.isMocEnabled)
        return {isMocReady: true, isMocEnabled: data.isMocEnabled}
      })
    }

    console.log('MOC ready: true MOC enabled: ', data.isMocEnabled)
    return {isMocReady: true, isMocEnabled: data.isMocEnabled}
  })
}
